<button mat-raised-button *appRoles="['Documentos.Crear']" color="primary" [routerLink]="['/documentos/nuevo']">
    <mat-icon>add</mat-icon>
    Nuevo documento
</button>
